<script lang="ts">
	import { route } from '$lib/ROUTES'
	import { Icons } from '$lib/components/icon'
	import InfoMessage from '$lib/components/infoMessage/InfoMessage.svelte'
	import { UserRole, isRole } from '$lib/components/role/role'
	import SignUpAffiliate from '$lib/domain/signUp/SignUpAffiliate.svelte'
	import { title } from '@helpers/title'
	import { Button } from '@repo/ui'
	import { account } from '@store/account'
	import { _ } from 'svelte-i18n'
</script>

<svelte:head>
	<title>{title($_('title.signUp'))}</title>
</svelte:head>

{#if isRole(UserRole.Admin, $account)}
	<div class="mt-4"></div>
	<InfoMessage text={$_('signUp.loggedAdmin')} />
{:else if isRole(UserRole.Affiliate, $account)}
	<div class="mt-4"></div>
	<InfoMessage text={$_('signUp.loggedAffiliate')} />

	<div class="mt-7"></div>

	<Button
		name="affiliate-continue"
		href={route('/dashboard')}
		icon={Icons.Squares2x2}
		label={$_('signUp.goToDashboard')}
	/>
{:else}
	<SignUpAffiliate />
{/if}
